import { MODULE } from "./sortFilter.actionTypes";

export const getSelectedSortingOption = (state) => state.getIn([MODULE, "selectedSortingOption"]);

export default {};
